/**
 * Regex pattern for matching preview index files
 */
const PREVIEW_PATTERN = /^\/index\.([\da-f]{40})\.html/;

/**
 * Determine whether the current URL is a preview URL
 */
export const isPreviewing = (): boolean => {
  const { location: { pathname = '' } = {} } = window;
  return PREVIEW_PATTERN.test(pathname);
};
